import { logDatapoint as logDatapointCore, logDatapointWithObservation, } from "owa-analytics-core/lib/loggingFunctions/logDatapoint";
import type { LogDatapointParams } from "owa-analytics-types";
import { getAnalyticsAddon } from "owa-analytics-addons";
import { getThreadName } from "owa-thread-config";
import { queueOrRun } from "owa-analytics-utils";
import { getLogDatapointObserver } from "owa-analytics-utils/lib/logDatapointObservation";
import { logToTracingPanel } from "../../utils/logToTracingPanel";
import { getAnalyticsFlightsAndAppSettings } from "owa-analytics-core/lib/settings/getAnalyticsFlightsAndAppSettings";
import { isRunningOnWorker } from "owa-config";
import { enrichDatapointWithAppVisibility } from "owa-analytics-core";
import { trace } from "owa-trace";

export function logDatapoint(...args: LogDatapointParams): void {
    const [datapoint, , observation] = args;
    if (observation && !getLogDatapointObserver(observation)?.isActive()) {
        return;
    }
    logToTracingPanel(datapoint);
    enrichDatapointWithAppVisibility(datapoint);
    
    queueOrRun<LogDatapointParams>("logDatapoint", logDatapointFunction, ...args);
}

export function logDatapointFunction(...args: LogDatapointParams): void {
    const [datapoint, overrideEventType, observation] = args;
    if (observation && !getLogDatapointObserver(observation)?.isActive()) {
        return;
    }
    if (getThreadName() === "MAIN_THREAD") {
        getAnalyticsAddon("LogInWorkerOrMainThread")?.executeWhenReady(observation ? dispatchObservedDatapoint : logDatapointCore, "logDatapoint", ...args);
    }
    else if (observation) {
        dispatchObservedDatapoint(datapoint, overrideEventType, observation);
    }
    else {
        logDatapointCore(datapoint, overrideEventType);
    }
    
    if (!isRunningOnWorker() && getAnalyticsFlightsAndAppSettings()?.devToolsEnabled) {
        getAnalyticsAddon("LogUnifiedTelemetryDiagnostics")?.executeWhenReady(datapoint);
    }
}

function dispatchObservedDatapoint(...args: LogDatapointParams): void {
    const [datapoint, overrideEventType, observation] = args;
    if (!observation) {
        trace.warn("Config-state dispatch is missing its observation.", "analytics");
        return;
    }
    void logDatapointWithObservation(datapoint, overrideEventType, observation).catch(() => {
        trace.warn("Config-state core dispatch failed.", "analytics");
    });
}
